import { render, staticRenderFns } from "./StampCollectedTopIcon.vue?vue&type=template&id=d9942528&scoped=true&lang=pug&"
import script from "./StampCollectedTopIcon.vue?vue&type=script&lang=js&"
export * from "./StampCollectedTopIcon.vue?vue&type=script&lang=js&"
import style0 from "./StampCollectedTopIcon.vue?vue&type=style&index=0&id=d9942528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9942528",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
